import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faShoppingCart, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./navbar.css";

function Navbar() {
  const [showSearch, setShowSearch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim() !== "") {
      navigate(`/shop?search=${query}`);
      setShowSearch(false);
      setQuery("");
      setMenuOpen(false);
    }
  };

  return (
    <nav className="navbar">

      {/* Logo */}
      <div className="navbar-left">
        <Link to="/">
          <img src="/Tote.png" alt="Logo" className="logo" />
        </Link>
      </div>

      {/* Hamburger (Mobile Only) */}
      <button 
        className="menu-btn"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
      </button>
{/* Center Brand */}
<div className="navbar-center">
  <Link to="/" className="brand-text">Tote Therapy</Link>
</div>
      {/* Right Menu */}
      <div className={`navbar-right ${menuOpen ? "active" : ""}`}>

        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
        <Link to="/shop" onClick={() => setMenuOpen(false)}>Shop</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

        {/* Search */}
        <div className="search-wrapper">
          <button 
            className="icon-btn"
            onClick={() => setShowSearch(!showSearch)}
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>

          {showSearch && (
            <form className="search-box" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Search by title..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </form>
          )}
        </div>

        {/* Cart */}
        <Link to="/cart" className="cart-btn">
          <FontAwesomeIcon icon={faShoppingCart} />
        </Link>

      </div>
    </nav>
  );
}

export default Navbar;